// removed by extract-text-webpack-plugin
module.exports = {"flex":"FlexibleBlock__flex___1cNmk","flexOverflow":"FlexibleBlock__flexOverflow___33kIn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/FlexibleBlock.css
// module id = 1124
// module chunks = 4